import { ref, Ref } from 'vue';

export default function useBooleanToggle(toggled: boolean = false) {
    const isToggled: Ref<boolean> = ref(toggled);
    const toggle = () => {
        isToggled.value = !isToggled.value;
    };

    return {
        isToggled,
        toggle,
    };
}
